import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-down-left', 'CornerDownLeft', [["path",{"d":"M5 13.973h10a4 4 0 0 0 4-4V5M5 13.973l4.78-5.027M5 13.973 9.78 19","key":"svg-0"}]]);